var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionmarkHover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#3C3C3C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C3C3C",
  d: "M.5 15.5V.5h15v15z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.243 11.503h.89v-.89h-.89zm.639-7.232a1.417 1.417 0 0 1 1.59 1.317c0 .828-1.14 1.614-1.754 2.36-.247.237-.404.551-.444.89v.889s.889.01.889 0v-.89c0-.226.246-.431.444-.668.59-.708 1.689-1.44 1.689-2.58a2.245 2.245 0 0 0-2.414-2.086 2.44 2.44 0 0 0-2.414 1.756l.713.219a1.66 1.66 0 0 1 1.7-1.207",
  clipRule: "evenodd"
})));
export default SvgQuestionmarkHover;